import {
  Home, Building2, Users, Target, Warehouse, Landmark,
  ListChecks, CalendarDays, Sparkles, CalendarRange,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface NavItem { to: string; label: string; icon: LucideIcon; match?: string }

/** Left icon-rail entity navigation (spec §6). */
export const NAV: NavItem[] = [
  { to: '/', label: 'Home', icon: Home, match: '/' },
  { to: '/accounts', label: 'Accounts', icon: Building2, match: '/accounts' },
  { to: '/contacts', label: 'Contacts', icon: Users, match: '/contacts' },
  { to: '/opportunities', label: 'Opportunities', icon: Target, match: '/opportunities' },
  { to: '/properties', label: 'Properties', icon: Warehouse, match: '/properties' },
  { to: '/funds', label: 'Funds', icon: Landmark, match: '/funds' },
  { to: '/tasks', label: 'Tasks', icon: ListChecks, match: '/tasks' },
  { to: '/calendar', label: 'Calendar', icon: CalendarDays, match: '/calendar' },
  { to: '/insights', label: 'Insights', icon: Sparkles, match: '/insights' },
]

/** Events section (below the entity nav, above the M365 block). Items are
 *  permission-gated in LeftRail (crm.events.manage). */
export const EVENTS_NAV: NavItem[] = [
  { to: '/events/symposium', label: 'Investor Symposium', icon: CalendarRange, match: '/events/symposium' },
]

export const ESSENCE = 'Success. Earned daily.'
